/* eslint-disable */

const styles = [
  {
    type: 'href',
    body: '/css/normalize.css',
  },
  {
    type: 'href',
    body: '/css/webflow.css',
  },
  {
    type: 'href',
    body: '/css/pss-testing.webflow.css',
  },
  {
    type: 'sheet',
    body: '@media (min-width:992px){.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="48a5ceb2-f462-e915-2ea6-cfd4be0c8150"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="48a5ceb2-f462-e915-2ea6-cfd4be0c8144"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="88435d74-c3e5-edcd-fa84-cf2267841b05"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="88435d74-c3e5-edcd-fa84-cf2267841b02"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="88435d74-c3e5-edcd-fa84-cf2267841b03"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="88435d74-c3e5-edcd-fa84-cf2267841b07"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="88435d74-c3e5-edcd-fa84-cf2267841b09"]{opacity:0}}@media (max-width:991px) and (min-width:768px){.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="48a5ceb2-f462-e915-2ea6-cfd4be0c8150"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="48a5ceb2-f462-e915-2ea6-cfd4be0c8144"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="88435d74-c3e5-edcd-fa84-cf2267841b05"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="88435d74-c3e5-edcd-fa84-cf2267841b02"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="88435d74-c3e5-edcd-fa84-cf2267841b03"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="88435d74-c3e5-edcd-fa84-cf2267841b07"]{opacity:0}.af-view.w-mod-js:not(.w-mod-ix) [data-w-id="88435d74-c3e5-edcd-fa84-cf2267841b09"]{opacity:0}}',
  },
]

const loadingStyles = styles.map((style) => {
  let styleEl
  let loading

  if (style.type == 'href') {
    styleEl = document.createElement('link')

    loading = new Promise((resolve, reject) => {
      styleEl.onload = resolve
      styleEl.onerror = reject
    })

    styleEl.rel = 'stylesheet'
    styleEl.type = 'text/css'
    styleEl.href = style.body
  }
  else {
    styleEl = document.createElement('style')
    styleEl.type = 'text/css'
    styleEl.innerHTML = style.body

    loading = Promise.resolve()
  }

  document.head.appendChild(styleEl)

  return loading
})

export default Promise.all(loadingStyles).then(() => {
  const styleSheets = Array.from(document.styleSheets).filter((styleSheet) => {
    return styleSheet.href && styles.some((style) => {
      return style.type == 'href' && styleSheet.href.match(style.body)
    })
  })
  styleSheets.forEach((styleSheet) => {
    Array.from(styleSheet.rules).forEach((rule) => {
      if (rule.selectorText) {
        rule.selectorText = rule.selectorText
          .replace(/\.([\w_-]+)/g, '.af-class-$1')
          .replace(/\[class(.?)="( ?)([^"]+)( ?)"\]/g, '[class$1="$2af-class-$3$4"]')
          .replace(/([^\s][^,]*)(\s*,?)/g, '.af-view $1$2')
          .replace(/\.af-view html/g, '.af-view')
          .replace(/\.af-view body/g, '.af-view')
          .replace(/af-class-w-/g, 'w-')
          .replace(/af-class-anima-/g, 'anima-')
          .replace(/af-class-([\w_-]+)an-animation([\w_-]+)/g, '$1an-animation$2')
      }
    })
  })
})

/* eslint-enable */